// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () =>
    import("apps/partner-overview/PartnerOverviewEntry"),
  orderPrio: 85,
  iconType: "bar-chart",
  name: "partner-overview"
}: AppType)
